import { Link } from 'react-router-dom';

import ImgSlot from '@/ui/ImgSlot';
import type { Resident } from '@/types';

import styles from './ArtCardIndex.module.css';

interface ArtCardIndexProps {
  artist: Resident;
  index: number;
}

export default function ArtCardIndex({ artist, index }: ArtCardIndexProps) {
  const num = '/' + String(index + 1).padStart(3, '0');
  const href = `/artists/${artist.slug}`;

  return (
    <Link to={href} className={styles.cell} aria-label={artist.name}>
      <span className={styles.num}>{num}</span>
      <span className={styles.plate}>
        <ImgSlot src={artist.portraitUrl} alt={artist.name} label={artist.name} mono />
      </span>
      <span className={styles.name}>{artist.name}</span>
      <span className={styles.role}>
        {artist.role} · {artist.tag} · SINCE {artist.since}
      </span>
      <span className={styles.bio}>{artist.bio}</span>
      <div className={styles.meter}>
        {Array.from({ length: 28 }, (_, k) => (
          <i key={k} style={{ height: `${20 + ((k * 37) % 80)}%` }} />
        ))}
      </div>
    </Link>
  );
}
